export const PROJECT_DATA = [
  {
    position: "right",
    link: "https://raw.githubusercontent.com/tusharkhatri434/my-project-assets/master/P0.png",
    title: "Crackflix-GPT",
    date: "(AUGUST 2024) 🚀",
    desc: "Built with React, Firebase, and TMDB-API, Crackflix show trending movies list with Trailers with netflix streaming theme",
    tags: ["React", "Vercel", "TMDB-API", "Firebase"],
     live:"https://crackflix.vercel.app/",
    github: "https://github.com/tusharkhatri434/",
  },
  {
    position: "left",
    link: "https://raw.githubusercontent.com/tusharkhatri434/my-project-assets/master/p1.png",
    title: "Youtube Clone",
    date: "(AUGUST 2023) 🚀",
    desc: "Built with React, Tailwind, and Redux, my YouTube clone offers efficient API calls with debouncing search filters, delivering top-notch user experience.",
    tags: ["tailwind", "React", "Redux", "Live Chat"],
     live:"https://my-youtube-lake.vercel.app/",
    github: "https://github.com/tusharkhatri434/my-youtube",
  },
  {
    position: "right",
    link: "https://raw.githubusercontent.com/tusharkhatri434/my-project-assets/master/p3.png",
    title: "FoodVilla",
    date: "(MARCH 2023) 🎪",
    desc: "FoodVill web app, created with React, Tailwind, Redux Toolkit, and Jest testing, fully responsive streamlines online business with API-driven search filters and cart functionality.",

    tags: ["tailwind", "React", "Redux", "React-Router-dom"],
    live: "https://food-villa1.netlify.app/",
    github: "https://github.com/tusharkhatri434/food-villa",
  },
  {
    position: "left",
    link: "https://raw.githubusercontent.com/tusharkhatri434/my-project-assets/master/p4.png",
    title: "To-DO App",
    date: "(FEBRUARY 2023) 📲",
    desc: "My to-do app, designed with pure HTML, CSS, and JS, offers full CRUD functionality and responsive design for seamless task management.",
    tags: ["Html", "CSS3", "JavaScript"],
    live: "https://to-do-app-tushar-khatri.netlify.app/",
    github: "https://github.com/tusharkhatri434/To-do_App",
  },
  {
    position: "right",
    link: "https://raw.githubusercontent.com/tusharkhatri434/my-project-assets/master/p5.png",
    title: "Drum Sticks",
    date: "(October 2022) 🥁",
    desc: "Developed an interactive drum kit that plays different sounds when users click on various drum parts.",
    tags: ["Html", "CSS3", "JavaScript"],
    live: "https://tushar-drum-kit.netlify.app/",
    github: "https://github.com/tusharkhatri434/drum-stick/tree/master",
  },
];
